<img src="/assets/Ipaam-Poster-Road-Map-Edit-2.jpg" alt="" style="max-width: 100%; height: auto;" (click)="click()" />
